module.exports = __webpack_public_path__ + "img/mm-rep.9b254537.svg";